/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */
import {
    HttpClient,
    HttpHeaders,
    HttpResponse as AngularHttpResponse,
} from '@angular/common/http';
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    CurrentUserBuildingPermissionResponse,
    GetCurrentUserNotificationPreferencesParams,
    GetMeResponse,
    ImportCsvRecipientsRequest,
    ImportCsvRecipientsResponse,
    NotificationPreferencesResponse,
    ReleaseNoteReadStatusResponse,
    UpdateNotificationPreferencesRequest,
    UpdateUserMeNotificationPreferenceParams,
    UserResponse,
} from '../core-models';

interface HttpClientOptions {
    readonly headers?: HttpHeaders | Record<string, string | string[]>;
    readonly context?: HttpContext;
    readonly params?:
        | HttpParams
        | Record<
              string,
              string | number | boolean | Array<string | number | boolean>
          >;
    readonly reportProgress?: boolean;
    readonly withCredentials?: boolean;
    readonly credentials?: RequestCredentials;
    readonly keepalive?: boolean;
    readonly priority?: RequestPriority;
    readonly cache?: RequestCache;
    readonly mode?: RequestMode;
    readonly redirect?: RequestRedirect;
    readonly referrer?: string;
    readonly integrity?: string;
    readonly referrerPolicy?: ReferrerPolicy;
    readonly transferCache?: { includeHeaders?: string[] } | boolean;
    readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
    readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
    readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
    readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
    readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue =
    | string
    | number
    | boolean
    | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys?: ReadonlySet<string>,
    preserveRequiredNullables?: false,
    passthroughKeys?: undefined
): Record<string, AngularHttpParamValue>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> | undefined,
    preserveRequiredNullables: true,
    passthroughKeys?: undefined
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> | undefined,
    preserveRequiredNullables: boolean | undefined,
    passthroughKeys: ReadonlySet<string>
): Record<string, unknown>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> = new Set(),
    preserveRequiredNullables = false,
    passthroughKeys: ReadonlySet<string> = new Set()
): Record<string, unknown> {
    const filteredParams: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(params)) {
        if (passthroughKeys.has(key)) {
            if (value !== undefined) {
                filteredParams[key] = value;
            }
            continue;
        }
        if (Array.isArray(value)) {
            const filtered = value.filter(
                (item) =>
                    item != null &&
                    (typeof item === 'string' ||
                        typeof item === 'number' ||
                        typeof item === 'boolean')
            ) as Array<string | number | boolean>;
            if (filtered.length) {
                filteredParams[key] = filtered;
            }
        } else if (value === null && requiredNullableKeys.has(key)) {
            // With a paramsSerializer (preserveRequiredNullables) the literal null
            // is passed through for it to consume; without one, emit an empty
            // string so the required key still reaches the wire as `?key=`
            // instead of being silently dropped. See #3712.
            filteredParams[key] = preserveRequiredNullables ? null : '';
        } else if (
            value != null &&
            (typeof value === 'string' ||
                typeof value === 'number' ||
                typeof value === 'boolean')
        ) {
            filteredParams[key] = value;
        }
    }
    return filteredParams;
}

@Injectable({ providedIn: 'root' })
export class UsersApiService {
    private readonly http = inject(HttpClient);
    /**
     * Extracts, normalizes, and deduplicates literal email addresses from one CSV file without creating users or invitations.
     * @summary Extract recipient emails from CSV
     */
    createRecipientImportCsv<TData = ImportCsvRecipientsResponse>(
        importCsvRecipientsRequest: ImportCsvRecipientsRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createRecipientImportCsv<TData = ImportCsvRecipientsResponse>(
        importCsvRecipientsRequest: ImportCsvRecipientsRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createRecipientImportCsv<TData = ImportCsvRecipientsResponse>(
        importCsvRecipientsRequest: ImportCsvRecipientsRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createRecipientImportCsv<TData = ImportCsvRecipientsResponse>(
        importCsvRecipientsRequest: ImportCsvRecipientsRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const formData = new FormData();
        formData.append(`file`, importCsvRecipientsRequest.file);

        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/recipient-imports/csv`,
                formData,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/recipient-imports/csv`,
                formData,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/recipient-imports/csv`,
            formData,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Retrieves the currently authenticated user's profile.
     * @summary Get current user
     */
    getMe<TData = GetMeResponse>(
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getMe<TData = GetMeResponse>(
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getMe<TData = GetMeResponse>(
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getMe<TData = GetMeResponse>(
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(`/@core/api/users/me`, {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'events',
            });
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(`/@core/api/users/me`, {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'response',
            });
        }

        return this.http.get<TData>(`/@core/api/users/me`, {
            ...(options as Omit<NonNullable<typeof options>, 'observe'>),
            observe: 'body',
        });
    }
    /**
     * Retrieves role and permission keys for the authenticated user on one building.
     * @summary Get current user permission for a building
     */
    getCurrentUserBuildingPermissions<
        TData = CurrentUserBuildingPermissionResponse,
    >(buildingId: string, options?: HttpClientBodyOptions): Observable<TData>;
    getCurrentUserBuildingPermissions<
        TData = CurrentUserBuildingPermissionResponse,
    >(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getCurrentUserBuildingPermissions<
        TData = CurrentUserBuildingPermissionResponse,
    >(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getCurrentUserBuildingPermissions<
        TData = CurrentUserBuildingPermissionResponse,
    >(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/users/me/building-permissions/${buildingId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/users/me/building-permissions/${buildingId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/users/me/building-permissions/${buildingId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns the caller's global email switch and one searchable, paginated page of the buildings they can currently access.
     * @summary Get personal email notification preferences
     */
    getCurrentUserNotificationPreferences<
        TData = NotificationPreferencesResponse,
    >(
        params: GetCurrentUserNotificationPreferencesParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getCurrentUserNotificationPreferences<
        TData = NotificationPreferencesResponse,
    >(
        params: GetCurrentUserNotificationPreferencesParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getCurrentUserNotificationPreferences<
        TData = NotificationPreferencesResponse,
    >(
        params: GetCurrentUserNotificationPreferencesParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getCurrentUserNotificationPreferences<
        TData = NotificationPreferencesResponse,
    >(
        params: GetCurrentUserNotificationPreferencesParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/users/me/notification-preferences`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/users/me/notification-preferences`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/users/me/notification-preferences`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Saves one global or per-building email choice, then returns the confirmed state with the same page of buildings the caller was viewing (page, perPage and searchTerm query parameters).
     * @summary Update personal email notification preferences
     */
    updateUserMeNotificationPreference<TData = NotificationPreferencesResponse>(
        updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest,
        params: UpdateUserMeNotificationPreferenceParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateUserMeNotificationPreference<TData = NotificationPreferencesResponse>(
        updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest,
        params: UpdateUserMeNotificationPreferenceParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateUserMeNotificationPreference<TData = NotificationPreferencesResponse>(
        updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest,
        params: UpdateUserMeNotificationPreferenceParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateUserMeNotificationPreference<TData = NotificationPreferencesResponse>(
        updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest,
        params: UpdateUserMeNotificationPreferenceParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.patch<TData>(
                `/@core/api/users/me/notification-preferences`,
                updateNotificationPreferencesRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.patch<TData>(
                `/@core/api/users/me/notification-preferences`,
                updateNotificationPreferencesRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.patch<TData>(
            `/@core/api/users/me/notification-preferences`,
            updateNotificationPreferencesRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * @summary Get the connected user's organisation ID without updating login state
     */
    getCurrentUserOrganisation<TData = unknown>(
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getCurrentUserOrganisation<TData = unknown>(
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getCurrentUserOrganisation<TData = unknown>(
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getCurrentUserOrganisation<TData = unknown>(
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(`/@core/api/users/me/organisation`, {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'events',
            });
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(`/@core/api/users/me/organisation`, {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'response',
            });
        }

        return this.http.get<TData>(`/@core/api/users/me/organisation`, {
            ...(options as Omit<NonNullable<typeof options>, 'observe'>),
            observe: 'body',
        });
    }
    /**
     * @summary Get whether the current user has read a release-note version
     */
    getCurrentUserReleaseNotesReadStatus<TData = ReleaseNoteReadStatusResponse>(
        version: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getCurrentUserReleaseNotesReadStatus<TData = ReleaseNoteReadStatusResponse>(
        version: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getCurrentUserReleaseNotesReadStatus<TData = ReleaseNoteReadStatusResponse>(
        version: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getCurrentUserReleaseNotesReadStatus<TData = ReleaseNoteReadStatusResponse>(
        version: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/users/me/release-notes/${version}/read-status`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/users/me/release-notes/${version}/read-status`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/users/me/release-notes/${version}/read-status`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Mark a release-note version read for the current user
     */
    createUserMeReleaseNoteReadStatu<TData = ReleaseNoteReadStatusResponse>(
        version: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createUserMeReleaseNoteReadStatu<TData = ReleaseNoteReadStatusResponse>(
        version: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createUserMeReleaseNoteReadStatu<TData = ReleaseNoteReadStatusResponse>(
        version: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createUserMeReleaseNoteReadStatu<TData = ReleaseNoteReadStatusResponse>(
        version: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/users/me/release-notes/${version}/read-status`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/users/me/release-notes/${version}/read-status`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/users/me/release-notes/${version}/read-status`,
            undefined,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Retrieves a user by ID.
     * @summary Get user by ID
     */
    getUserById<TData = UserResponse>(
        userId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getUserById<TData = UserResponse>(
        userId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getUserById<TData = UserResponse>(
        userId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getUserById<TData = UserResponse>(
        userId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(`/@core/api/users/${userId}`, {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'events',
            });
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(`/@core/api/users/${userId}`, {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'response',
            });
        }

        return this.http.get<TData>(`/@core/api/users/${userId}`, {
            ...(options as Omit<NonNullable<typeof options>, 'observe'>),
            observe: 'body',
        });
    }
}
